import axios from "axios";

export const resetPassword = async (username: string): Promise<void> => {
  await axios.post("/pf-auth/reset-password", { username });
};

export const setNewPassword = async (payload: {
  secret_token: string;
  password: string;
  confirm_password: string;
}): Promise<void> => {
  await axios.post("/pf-auth/reset-password/set", payload);
};

interface AuthenticateUserPayload {
  username: string;
  password: string;
  code: string;
}

interface AuthenticateUserResponse {
  user_email: string | null;
  user_id: string | null;
  status: "2fa_required" | "success";
}

export const authenticateUser = async (payload: AuthenticateUserPayload) => {
  const response = await axios.post<AuthenticateUserResponse>("/pf-auth/login", payload);

  return response.data;
};
